import React from 'react'
import { IconButton, ListItem, MenuOverlay } from '@fs/zion-ui'
import { HelpAnnouncement } from '@fs/zion-icon'
import { useHelpOverlay } from '@fs/zion-help-overlay'
import { useTranslation } from 'react-i18next'
import { useFeatureFlag } from '@fs/zion-flags'

export default function WhatsNew({ canAccessFGT, canAccessCET }) {
  const [t] = useTranslation()
  const treeHelpOverlay = useHelpOverlay(
    'https://www.familysearch.org/en/help/helpcenter/article/family-tree-whats-new'
  )
  const researchHelpOverlay = useHelpOverlay(
    'https://www.familysearch.org/en/help/helpcenter/article/how-do-i-create-a-free-familysearch-account'
  )
  const groupsHelpOverlay = useHelpOverlay(
    'https://www.familysearch.org/help/helpcenter/article/family-group-whats-new'
  )
  const cetWhatsNewIsOn = useFeatureFlag('treeWeb_researchTrees_whatsNew').isOn

  return (
    <MenuOverlay
      menuButton={
        <IconButton
          Icon={HelpAnnouncement}
          color="gray"
          title={t('subnav-legacy.whats-new.label')}
          data-testid="whats-new-party-button"
        />
      }
    >
      <ListItem
        primaryText={t('subnav-legacy.whats-new-trees.label')}
        onClick={treeHelpOverlay.handleClick}
        data-testid="whats-new-tree-button"
      />
      {canAccessCET && cetWhatsNewIsOn && (
        <ListItem
          primaryText={t('subnav-legacy.whats-new-research-trees.label')}
          onClick={researchHelpOverlay.handleClick}
          data-testid="whats-new-research-tree-button"
        />
      )}
      {canAccessFGT && (
        <ListItem
          primaryText={t('subnav-legacy.whats-new-groups-trees.label')}
          onClick={groupsHelpOverlay.handleClick}
          data-testid="whats-new-family-group-tree-button"
        />
      )}
    </MenuOverlay>
  )
}
